// banner 配置
export const banner = {
  cover: 'https://img.alicdn.com/tfs/TB1in9UJiLaK1RjSZFxXXamPFXa-1920-627.png',
  mcover: 'https://gw.alicdn.com/tfs/TB1FV46M9zqK1RjSZFLXXcn2XXa-750-320.png',
  title: '关于我们',
};

const joinus = [
  '充满激情，乐观向上，永不放弃',
  '敬业乐群，专业执着，精益求精',
  '运用先进技术，挖掘医疗数据价值',
  '期待和你一起，开创更美好的未来',
];

const abouts = [
  {
    tag: '办公环境',
    cover: 'https://img.alicdn.com/tfs/TB1RGPsPgTqK1RjSZPhXXXfOFXa-740-512.jpg',
    title: '优美舒适的办公环境',
  },
  {
    tag: '员工福利',
    cover: 'https://img.alicdn.com/tfs/TB1Pi_rPmrqK1RjSZK9XXXyypXa-740-512.jpg',
    title: '温暖人心的员工福利',
  },
  {
    tag: '团建活动',
    cover: 'https://img.alicdn.com/tfs/TB1k5DuPmzqK1RjSZPxXXc4tVXa-740-512.jpg',
    title: '轻松有意思的团建活动',
  },
];

const informations = [
  {
    title: '关于扁鹊',
    img: 'https://img.alicdn.com/tfs/TB1M0cVJgDqK1RjSZSyXXaxEVXa-753-590.jpg',
    mimg: 'https://gw.alicdn.com/tfs/TB14UKPPkvoK1RjSZFDXXXY3pXa-750-960.jpg',
    content: [
      '浙江扁鹊是一家医疗大数据服务供应商，致力于运用先进的技术，深挖医疗数据价值。利用当下先进技术手段合规挖掘数据价值，并在卫生服务、行政监管、便民体验及人工智能等领域开展多种应用探索和研究。公司成立于 2018 年 3 月，注册资本 4500 万元，由弘云久康数据技术(北京)有限公司投资，弘云久康是阿里健康的附属公司。6 月 1 日，阿里健康公布，公司附属公司弘云久康、上海云鑫、杭州云庭与浙江扁鹊订立增资协议，上海云鑫及杭州云庭以现金分別向浙江扁鹊注册资本注资，金额分別为 4000 万元及 1500 万元。至此，浙江扁鹊注册资本由 4500 万元增至 1 亿元，将分別由阿里健康附属弘云久康、上海云鑫及杭州云庭分别持有 45%、40% 及 15%。至此，通过浙江扁鹊，阿里健康的医疗信息化布局已初具规模。',
    ],
  },
  {
    title: '扁鹊文化',
    img: 'https://img.alicdn.com/tfs/TB13qCNJgHqK1RjSZFkXXX.WFXa-970-760.jpg',
    mimg: 'https://gw.alicdn.com/tfs/TB1bmnkOgHqK1RjSZFgXXa7JXXa-750-712.png',
    content: [
      '客户第一：客户是衣食父母',
      '团队合作：共享共担，平凡人做非凡事',
      '拥抱变化：迎接变化，勇于创新',
      '诚信：诚实正直，言行坦荡',
      '激情：乐观向上，永不放弃',
      '敬业：专业执着，精益求精',
    ],
  },
];

const jobs = [
  {
    // icon: 'https://img.alicdn.com/tfs/TB1Cf5wJmrqK1RjSZK9XXXyypXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1EZ4XOhTpK1RjSZR0XXbEwXXa-176-176.png',
    micon: 'https://gw.alicdn.com/tfs/TB1EZ4XOhTpK1RjSZR0XXbEwXXa-176-176.png',
    name: '大数据开发工程师',
    color: '8083b4',
    description: [
      {
        title: '职位描述',
        content: [
          '1、熟悉服务器存储网络OS等基础架构基本元素，熟悉 linux 操作系统，具备较强的调优排障能力；',
          '2、熟悉 Hadoop、Spark 等大数据框架，有大型分布式计算开发、部署等相关经验；',
          '3、熟悉 shellpython 或其他脚本语言中的任意一门，有扎实的 Java 开发基础，了解 jvm 的运行机制以及相应调优；',
          '4、能够独立完成项目的系统分析、设计，并主导完成详细设计和编码的任务；',
          '5、注重性能，良好的代码管理及重构意识。具备独立沟通需求，设计，架构，开发的能力；',
          '6、熟悉主流的数据存储产品，有开发经验者优先。如：HBase，Hive，Redis，MongoDB，MySQL 等；',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1qi56JhnaK1RjSZFtXXbC2VXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB14yxfOcbpK1RjSZFyXXX_qFXa-170-154.png',
    micon: 'https://gw.alicdn.com/tfs/TB14yxfOcbpK1RjSZFyXXX_qFXa-170-154.png',
    name: 'JAVA工程师',
    color: '8fc4ab',
    description: [
      {
        title: '职位描述',
        content: [
          '1、业务需求的设计和实现，同时可以形成沉淀和复用架构/服务；',
          '2、技术预研和技术难点攻关，保障系统可用性、稳定性、和可扩展性；',
          '3、项目的总体架构设计与风险控制；',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、JAVA 基础扎实，理解 io、多线程、集合等基础框架，对 JVM 原理有全面的了解，拥有领域模型抽象能力；',
          '2、对 Spring,ibatis,struts 等开源框架熟悉；',
          '3、熟悉分布式系统的设计和应用，熟悉分布式、缓存、消息等机制；能对分布式常用技术进行合理应用，解决问题；',
          '4、掌握多线程及高性能的设计与编码及性能调优；有高并发应用开发经验；',
          '5、掌握 Linux 操作系统和大型数据库（Oracle、MySql）；对 sql 优化有丰富的经验；',
          '6、学习能力强，适应能力好；具备耐心/细心的品质；',
          '7、喜欢去看及尝试最新的技术，追求编写优雅的代码，从技术趋势和思路上能影响技术团队；',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1bvSAJbPpK1RjSZFFXXa5PpXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1cXg7N6DpK1RjSZFrXXa78VXa-170-198.png',
    micon: 'https://gw.alicdn.com/tfs/TB1cXg7N6DpK1RjSZFrXXa78VXa-170-198.png',
    name: '互联网医疗产品经理',
    color: '3488c9',
    description: [
      {
        title: '职位描述',
        content: [
          '1、理解和挖掘大众对健康信息和医疗服务的需求，抽象产品的使用场景进行产品规划和设计；',
          '2、负责通过数据分析、用户研究不断挖掘用户需求，输出解决方案，搭建和完善产品体系；',
          '3、流程化开发运营管理，确保开发流程高效运转；',
          '4、跨部门工作的协调与沟通、支持配合；',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、5 年及以上产品经验，有互联网产品设计经验，医疗行业背景经验者优先；',
          '2、积极思考，不拘泥于现有产品形式，有创新的思维，对移动端产品有敏锐的触觉；',
          '3、拥有较强的执行力，自我驱动，责任心强，以结果为导向；',
          '4、对于行业主流医疗产品有过深入研究，具有良好的互联网思维；',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1oMiGJbrpK1RjSZTEXXcWAVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1KxdeOkzoK1RjSZFlXXai4VXa-146-176.png',
    micon: 'https://gw.alicdn.com/tfs/TB1KxdeOkzoK1RjSZFlXXai4VXa-146-176.png',
    name: '项目经理',
    color: 'f9cb4b',
    description: [
      {
        title: '职位描述',
        content: [
          '1、负责程序调试、项目实施工作；',
          '2、负责项目整体协调、进度跟踪等监管工作；',
          '3、充分了解客户需求，建立良好的客户关系；',
          '4、能理解客户需求，推广公司相应产品；',
          '5、参与医疗信息化产品的路标规划,调研客户需求，沟通用户需求；',
          '6、跟踪上线产品的市场效果、用户反馈，收集和主动挖掘改进需求，根据业务需要持续改进产品，提升用户体验；',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、具有医疗行业 5 年以上的行业经验；',
          '2、从事过三甲医院整体项目的实施、维护或相关开发人员；或从事过区卫产品的实施、维护或相关开发人员；',
          '3、有医疗行业数据处理、分析经验人员优先考虑；',
          '4、具有一定的逻辑思维能力和数据敏感性；',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1cyiHJkvoK1RjSZFNXXcxMVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1TutBOhnaK1RjSZFBXXcW7VXa-158-142.png',
    micon: 'https://gw.alicdn.com/tfs/TB1TutBOhnaK1RjSZFBXXcW7VXa-158-142.png',
    name: '法务经理',
    color: 'F27954',
    description: [
      {
        title: '职位描述',
        content: [
          '1、全面负责公司的法务支持工作，就业务运营、技术开发服务、平台建设、用户运营、渠道业务、市场营销活动等，提供日常法律咨询、合同审查以及风险控制等法律事务；',
          '2、搭建项目法律架构，有效推进业务并评估/把控法律风险；',
          '3、参与公司重大项目谈判与合作，合规审核及法律风控支持；',
          '4、负责各项业务相关合同及规范性文件的谈判、起草、审核和规范；',
          '5、负责公司运营中的数据安全、个人信息保护等相关合规工作；',
        ],
      },
      {
        title: '职位要求',
        content: [
          '1、全日制法律专业本科及以上学历，持有法律职业资格证书；',
          '2、5 年以上法律工作经验，具备IT或数据业务的经验更佳，熟悉互联网行业或医药行业、药品经营的优先；',
          '3、具备较强的自我驱动能力，法律分析能力和解决问题的能力；',
          '4、对互联网行业、新商业模式有浓厚的兴趣；',
          '5、良好的沟通协调组织能力，具有团队协作精神，逻辑思维缜密，性格开朗，主动性强，敬业爱岗、可以适应出差，有很好的承压能力；',
        ],
      },
    ],
  },
  {
    // icon: 'https://img.alicdn.com/tfs/TB1_WKyJgDqK1RjSZSyXXaxEVXa-238-238.png',
    icon: 'https://img.alicdn.com/tfs/TB1qpJiOgHqK1RjSZJnXXbNLpXa-156-156.png',
    micon: 'https://gw.alicdn.com/tfs/TB1qpJiOgHqK1RjSZJnXXbNLpXa-156-156.png',
    name: '项目实施工程师',
    color: 'eb4446',
    description: [
      {
        title: '职位描述',
        content: [
          '1、计算机及相关专业，23-30 岁；',
          '2、一年以上软件行业项目实施经验信或售后服务经验；',
          '3、熟悉 .NET 和 JAVA 任何一门开发语言，熟练掌握 Oracle、Sql server 或 My Sql 数据库，有过软件开发经验者优先；',
          '4、具有较强的责任心，工作积极主动，有一定的项目组织及培训演讲能力；',
          '5、适应出差，沟通协调能力强；',
        ],
      },
      {
        title: '职位要求',
        content: [
          '制定项目实施计划方案，并按计划完成项目的安装、培训、调试、启用、验收、维护等工作，并保持良好的客户关系，同时配合部门进行质量监督。',
        ],
      },
    ],
  },
];

export const aboutData = {
  title: '关于我们',
  subtitle: 'about us',
  extra: {
    title: '查看全部',
    path: '/about',
  },
  path: '/about',
  slogan: '数据让健康触手可及',
  joinus,
  abouts,
  informations,
  jobs,
  map: 'https://img.alicdn.com/tfs/TB1UVDFqX67gK0jSZPfXXahhFXa-874-578.jpg',
  info: {
    tel: '4008558517',
    email: 'ping.chaip@alibaba-inc.com',
    address: '浙江省杭州市余杭区文一西路和绿汀路交叉口浙富西溪堂1号楼',
  },
};
